import { useTranslation } from "react-i18next";
import { useWebSocket } from "../../../../shared/contexts/WebSocketContext";
import { useRoomStore } from "../../model/roomStore";
import css from "./RoomConnectionError.module.scss";

/**
 * Ошибка подключения к выбранной комнате (§8 demo-lobby).
 *
 * Выбор пользователя сохраняется, переключать комнату автоматически нельзя:
 * можно только повторить подключение к той же комнате либо вернуться к
 * каталогу и запросить его заново.
 */
export const RoomConnectionError = () => {
  const { t } = useTranslation();
  const { status, reconnect } = useWebSocket();
  const selectedRoom = useRoomStore((state) => state.selectedRoom);
  const backToCatalog = useRoomStore((state) => state.backToCatalog);

  if (!selectedRoom || status !== "error") return null;

  return (
    <div className={css.overlay}>
      <div className={css.box}>
        <p className={css.room}>{selectedRoom.displayName}</p>
        <p className={css.text}>{t("rooms.connection_failed")}</p>
        <div className={css.actions}>
          <button type="button" className={css.primary} onClick={reconnect}>
            {t("rooms.retry_connection")}
          </button>
          <button
            type="button"
            className={css.secondary}
            onClick={backToCatalog}
          >
            {t("rooms.back_to_catalog")}
          </button>
        </div>
      </div>
    </div>
  );
};
